import { render } from "./select-api-url.vue?vue&type=template&id=39675311"
import script from "./select-api-url.vue?vue&type=script&lang=ts"
export * from "./select-api-url.vue?vue&type=script&lang=ts"
script.render = render

export default script